import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextareaAutosize,
  TextField,
  Typography,
  Paper,
  Chip,
} from "@mui/material";
import {
  FormProvider,
  RHFTextField,
  RHFCheckbox,
} from "../../../components/hook-form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { getFileUrl } from "../../../utils/firebaseUtils";
import { useTheme } from "@emotion/react";
import axios from "axios";
import Page from "../../../components/Page";
import { LoadingButton } from "@mui/lab";
import { toast, ToastContainer } from "react-toastify";
import { set } from "lodash";
import { useNavigate } from "react-router-dom";
import { Delete } from "@mui/icons-material";
import RHFTextEditor from "../../../components/hook-form/RHFTextEditor";
import DeleteIcon from "@mui/icons-material/Delete";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CreateLiveTest = ({ onSuccess }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  
  const resultOption = [
    { id: "manual", title: "Manual" },
    { id: "automatic", title: "Automatic" },
  ];

  const streamCategory = [
    { id: "class", title: "School Exams" },
    { id: "central-exam", title: "Central Exams" },
    { id: "state-exam", title: "State Exams" },
  ];

  const [focus, setFocused] = React.useState(false);
  const [focusTwo, setFocusedTwo] = React.useState(false);
  const [focusThree, setFocusedThree] = React.useState(false);
  const [showStartingDate, setShowStartingDate] = React.useState(false);
  const [showEndingDate, setShowEndingDate] = React.useState(false);
  const [upscData, setUpscData] = useState([]);
  const [upscId, setUpscId] = useState("");
  const [groupId, setGroupId] = useState("");
  const [showBanner, setShowBanner] = React.useState(false);
  const [val, setVal] = useState(false);
  const [file, setFile] = useState();
  const [selectedResultType, setSelectedResultType] = useState("");
  const [negativeMark, setNegativeMark] = useState("true");
  const [currentAffairId, setCurrentAffairId] = useState(null);
  const [subcategory2, setSubcategory2] = useState(null);

  const [category, setCategory] = useState("");
  const [exam, setExam] = useState("");
  const [selectedSubject, setSelectedSubject] = useState([]);

  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const subCategories2 = [{ id: 44, name: "EXAM LEVEL CURRENT AFFAIRS" }, { id: null, name: "No Selection" }];
  const [states, setStates] = useState();
  const [boards, setBoards] = useState();
  const [classVal, setClass] = useState(null);
  const [centralExam, setCentralExam] = useState(null);
  const [stateExam, setStateExam] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedBoard, setSelectedBoard] = useState(null);

  const [subjectList, setSubjectList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [isFree, setIsFree] = useState(false);
  const [selectedMedium, setSelectedMedium] = useState("");

  const [selSubject, setSelSubject] = useState([]);
  const [subjectError, setSubjectError] = useState("");
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [bannerUploading, setBannerUploading] = useState(false);
  const [bannerUploaded, setBannerUploaded] = useState(false);

  const handleAdd = () => {
    setSubjects([
      ...subjects,
      {
        id: Date.now(),
        name: "",
        subject_id: [],
        chapter_id: [],
        chapterOptions: [],
      },
    ]);
  };

  const handleDelete = (id) => {
    setSubjects(subjects.filter((subject) => subject.id !== id));
  };

  const handleChange = (id, key, value) => {
    setSubjects(
      subjects.map((subject) =>
        subject.id === id ? { ...subject, [key]: value } : subject
      )
    );
    if (key === "subject_id") {
      setSelSubject(value);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    async function fetchSubjects() {
      setLoading(true);
      try {
        const res = await fetch(
          `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-subject-by-goal`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              course: selectedCategory,
              language: selectedLanguage,
              class_exam_id: upscId === 3 ? groupId : centralExam || stateExam ? centralExam || stateExam : classVal,
              ...(currentAffairId !== null && { current_affair_id: currentAffairId })
            }),
          }
        );
        const resSubject = await res.json();
        const filteredSubjects = resSubject?.data?.map((subject) => ({
          id: subject.subject_id,
          name: subject.subject_name,
        }));
        setSubjectList(filteredSubjects || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    }
    fetchSubjects();
  }, [centralExam, stateExam, classVal, selectedLanguage, currentAffairId]);

  const handleCategoryChange = async (event) => {
    const selectedCategoryId = event.target.value;
    setStates(null);
    setBoards(null);
    setSubCategories(null);
    setSelectedBoard(null);
    setSelectedState(null);

    setIsCategoryLoading(true);
    setSelectedCategory(selectedCategoryId);

    const token = localStorage.getItem("token");
    switch (selectedCategoryId) {
      case "central-exam":
        const centralExams = await axios.post(
          `${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-central-exams`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setSubCategories(centralExams?.data?.data);
        break;

      case "state-exam":
        const stateList = await axios.post(
          `${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-states`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setStates(stateList?.data?.data);
        break;

      case "class":
        const boardsList = await axios.post(
          `${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-boards`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setBoards(boardsList?.data?.data);
        break;

      default:
        break;
    }
    setIsCategoryLoading(false);
  };

  const handleStateChange = async (e) => {
    setIsCategoryLoading(true);
    setSelectedState(e.target.value);
    const currentState = e.target.value;
    setSubCategories(null);
    const stateExamsList = await axios.post(
      `${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-state-exams`,
      { state_exam_id: currentState }
    );
    setSubCategories(stateExamsList.data?.data);
    setIsCategoryLoading(false);
  };

  const handleBoardChange = async (e) => {
    setIsCategoryLoading(true);
    const currentBoard = e.target.value;
    setSelectedBoard(e.target.value);
    setSubCategories(null);
    const boardExamsList = await axios.post(
      `${process.env.REACT_APP_LIVE_URL_NEW}/mobile/get-classes`,
      { board_id: currentBoard }
    );
    setSubCategories(boardExamsList.data?.data);
    setIsCategoryLoading(false);
  };

  const handleSubCategoryChange = (e) => {
    setClass(null);
    setStateExam(null);
    setCentralExam(null);
    setUpscId(e.target.value);
    if (boards) setClass(e.target.value);
    else if (states) setStateExam(e.target.value);
    else setCentralExam(e.target.value);
  };

  const LoginSchema = Yup.object().shape({
    name: Yup.string().required("Title is required"),
    duration: Yup.number()
      .required("Duration is required")
      .positive("Duration must be a positive number"),
    mark_each_question: Yup.number()
      .required("Marks per question is required")
      .positive("Marks per question must be a positive number"),
  });

  const defaultValues = {
    name: "",
    starting_date: "",
    ending_date: "",
    duration: "",
    mark_each_question: "",
    negative_mark: "",
    negative_marking: "true",
    category: "",
    exam: "",
    subjects: [],
    description: "",
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = methods;

  const changeHandler = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    try {
      setBannerUploading(true);
      const uploadedUrl = await getFileUrl(file);
      setFile(uploadedUrl);
      setBannerUploaded(true);
    } catch (err) {
      console.error("Banner upload failed", err);
      toast.error("Banner upload failed");
      setBannerUploaded(false);
    } finally {
      setBannerUploading(false);
    }
  };

  useEffect(() => {
    if (resultOption?.length > 1 && !selectedResultType) {
      setSelectedResultType(resultOption[1].id);
    }
  }, [resultOption, selectedResultType]);

  const handleResultTypeChange = (event) => {
    setSelectedResultType(event.target.value);
  };

  const onSubmit = async (data) => {
    setHasSubmitted(true);
    if (!validateSubjects()) {
      setSubjectError("Please add at least one subject with name and subject.");
      return;
    }

    const startingDate = data.starting_date;
    const endingDate = data.ending_date;
    
    setLoading(true);

    const payload = {
      name: data.name,
      image: file,
      starting_date: startingDate,
      ending_date: endingDate,
      duration: data.duration,
      mark_each_question: data.mark_each_question,
      negative_mark: data.negative_mark,
      negative_marking: negativeMark,
      subject_id: [],
      subjects: subjects,
      result_type: selectedResultType,
      is_active: true,
      instructions: "Please follow the instructions carefully.",
      attempted: 0,
      mock_test_type: 1,
      subject_name: "Physics",
      course: selectedCategory,
      state_exam_id: selectedState,
      board_id: selectedBoard,
      exam_id: centralExam === 3 ? groupId : centralExam || stateExam,
      class_id: classVal,
      subCategory: data?.subCategory,
      subcategory2: subcategory2,
      description: data?.description,
      isLive: 1, // Preset/hardcoded to Live test!
      isFree: isFree ? 1 : 0,
      group_id: groupId,
      language: selectedLanguage,
      medium: selectedMedium,
    };

    const token = localStorage.getItem("token");
    const res = await fetch(
      `${process.env.REACT_APP_LIVE_URL_NEW}/admin/create-mock-test`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );
    setLoading(false);
    const response = await res.json();
    if (response?.response_code === 200) {
      toast.success("Live Test Created Successfully");
      setTimeout(() => {
        if (onSuccess) {
          onSuccess();
        } else {
          navigate("/dashboard/liveTest");
        }
      }, 1000);
    }
  };

  const validateSubjects = () => {
    const validSubjects = subjects.filter(
      (sub) => sub.name && sub.subject_id && sub.subject_id.length > 0
    );
    return validSubjects.length > 0;
  };

  const fetchLanguages = async () => {
    const token = localStorage.getItem("token");
    try {
      const languageData = await axios.post(
        `${process.env.REACT_APP_LIVE_URL_NEW}/mobile/user/get-mediums`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (languageData?.status !== 200)
        throw new Error("Failed to fetch languages");

      setLanguages(languageData?.data?.data);
      if (languageData?.data?.data?.length) {
        setSelectedLanguage(languageData?.data?.data[0].medium_code);
        setSelectedMedium(languageData?.data?.data[0].id);
      }
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  useEffect(() => {
    fetchLanguages();
  }, []);

  return (
    <Page title="Create Live Test">
      <Box sx={{ width: "95%", margin: "auto", p: 3 }}>
        <Typography className="page-heading" sx={{ mb: 3 }}>
          Create New Live Test
        </Typography>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2} sx={{ my: 2 }}>
            <RHFTextField name="name" label="Mock Test Title" />
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} spacing={2}>
            <Stack direction="column" sx={{ width: "49%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                Banner Upload
              </Typography>
              <TextField
                type="file"
                name="image"
                onChange={changeHandler}
                disabled={bannerUploading}
              />
              {bannerUploading && <Typography sx={{ mt: 1 }}>Uploading banner...</Typography>}
              {bannerUploaded && <Typography sx={{ mt: 1, color: "green" }}>Banner uploaded!</Typography>}
            </Stack>
            <Stack direction={"column"} sx={{ width: "49%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                Result Type
              </Typography>
              <RHFTextField
                name="result_type"
                label="Select Result Type"
                sx={{ width: "100%" }}
                select
                value={selectedResultType}
                onChange={handleResultTypeChange}
              >
                {resultOption?.map((item, index) => (
                  <MenuItem key={index} value={item.id}>
                    {item.title}
                  </MenuItem>
                ))}
              </RHFTextField>
            </Stack>
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} spacing={2}>
            {/* Free */}
            <Stack direction="column" sx={{ width: "100%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                Free
              </Typography>
              <RHFTextField
                name="Free"
                select
                SelectProps={{ native: true }}
                value={isFree}
                onChange={(e) => setIsFree(e.target.value === "true")}
              >
                <option value="true">True</option>
                <option value="false">False</option>
              </RHFTextField>
            </Stack>
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} spacing={2}>
            <Stack direction="column" sx={{ width: "49%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                Language
              </Typography>
              <RHFTextField
                name="language"
                select
                SelectProps={{ native: true }}
                value={selectedLanguage}
                onChange={(e) => setSelectedLanguage(e.target.value)}
              >
                {languages.map((language) => (
                  <option key={language.id} value={language.medium_code}>
                    {language.medium_name}
                  </option>
                ))}
              </RHFTextField>
            </Stack>

            <Stack direction="column" sx={{ width: "49%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                Medium
              </Typography>
              <RHFTextField
                name="medium"
                select
                SelectProps={{ native: true }}
                value={selectedMedium}
                onChange={(e) => setSelectedMedium(e.target.value)}
              >
                {languages.map((language) => (
                  <option key={language.id} value={language.id}>
                    {language.medium_name}
                  </option>
                ))}
                <option value={3}>Both</option>
              </RHFTextField>
            </Stack>
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} spacing={2}>
            <Stack direction="column" sx={{ width: "49%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                Start Date
              </Typography>
              <RHFTextField
                name="starting_date"
                onFocus={() => setFocusedTwo(true)}
                onBlur={() => setFocusedTwo(false)}
                label="Starting Date"
                type="datetime-local"
                InputLabelProps={{ shrink: true }}
              />
            </Stack>
            <Stack direction="column" sx={{ width: "49%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                End Date
              </Typography>
              <RHFTextField
                name="ending_date"
                onFocus={() => setFocusedThree(true)}
                onBlur={() => setFocusedThree(false)}
                label="Ending Date"
                type="datetime-local"
                InputLabelProps={{ shrink: true }}
              />
            </Stack>
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} spacing={2}>
            <Stack direction="column" sx={{ width: "49%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                Test Duration (in Minutes)
              </Typography>
              <RHFTextField name="duration" label="Enter Duration" />
            </Stack>
            <Stack direction="column" sx={{ width: "49%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                Marks per Question
              </Typography>
              <RHFTextField name="mark_each_question" label="Enter Marks" />
            </Stack>
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} spacing={2}>
            <Stack direction="column" sx={{ width: "49%" }}>
              <Typography variant="h6" marginBottom={"0.5rem"}>
                Negative Marking Available
              </Typography>
              <RadioGroup
                row
                name="negative_marking"
                onChange={(e) => setNegativeMark(e.target.value)}
                value={negativeMark}
              >
                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                <FormControlLabel value="0" control={<Radio />} label="No" />
              </RadioGroup>
            </Stack>
            {negativeMark === "1" && (
              <Stack direction="column" sx={{ width: "49%" }}>
                <Typography variant="h6" marginBottom={"0.5rem"}>
                  Negative Marks Per Question
                </Typography>
                <RHFTextField name="negative_mark" label="Enter Marks" />
              </Stack>
            )}
          </Stack>

          <Stack direction={"row"} spacing={3} sx={{ my: 2 }}>
            <RHFTextField
              name="category"
              label="Category"
              required
              sx={{ width: "50%" }}
              select
              value={selectedCategory}
              onChange={handleCategoryChange}
            >
              {streamCategory?.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.title}
                </MenuItem>
              ))}
            </RHFTextField>

            {states && (
              <RHFTextField
                name="states"
                label="State"
                sx={{ width: "50%" }}
                select
                value={selectedState}
                onChange={handleStateChange}
              >
                {states?.map((state, index) => (
                  <MenuItem key={index} value={state.id}>
                    {state.name}
                  </MenuItem>
                ))}
              </RHFTextField>
            )}

            {boards && (
              <RHFTextField
                name="boards"
                label="Boards"
                sx={{ width: "50%" }}
                select
                value={selectedBoard}
                onChange={handleBoardChange}
              >
                {boards?.map((board, index) => (
                  <MenuItem key={index} value={board.id}>
                    {board.name}
                  </MenuItem>
                ))}
              </RHFTextField>
            )}

            <RHFTextField
              name="subCategory"
              label="Subcategory"
              sx={{ width: "50%" }}
              select
              onChange={handleSubCategoryChange}
            >
              {subCategories?.map((subcategory, index) => (
                <MenuItem key={index} value={subcategory.id}>
                  {subcategory?.name || subcategory?.class_name}
                </MenuItem>
              ))}
            </RHFTextField>
            
            {(selectedCategory === "central-exam" || selectedCategory === "state-exam") && (
              <RHFTextField
                name="subcategory2"
                label="Subcategory2"
                sx={{ width: "50%" }}
                select
                value={subcategory2}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setSubcategory2(selectedValue);
                  const newCurrentAffairId = selectedValue === 44 ? 44 : null;
                  setCurrentAffairId(newCurrentAffairId);
                }}
              >
                {subCategories2?.map((subcategory, index) => (
                  <MenuItem key={index} value={subcategory.id}>
                    {subcategory.name}
                  </MenuItem>
                ))}
              </RHFTextField>
            )}
          </Stack>

          <Stack sx={{ my: 2 }}>
            <Typography variant="h6" marginBottom={"0.5rem"}>
              Add Subjects
            </Typography>
            {subjectError && <Typography sx={{ color: "red", mb: 2 }}>{subjectError}</Typography>}
            {subjects.map((subject) => (
              <Paper key={subject.id} elevation={3} sx={{ p: 2, mb: 2, backgroundColor: "transparent" }}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <TextField
                    label="Subject Name"
                    variant="outlined"
                    value={subject.name}
                    onChange={(e) => handleChange(subject.id, "name", e.target.value)}
                    fullWidth
                    error={hasSubmitted && !subject.name}
                    helperText={hasSubmitted && !subject.name ? "Subject name is required" : ""}
                  />
                  <FormControl fullWidth error={hasSubmitted && subject.subject_id.length === 0}>
                    <InputLabel>Subjects</InputLabel>
                    <Select
                      multiple
                      value={subject.subject_id}
                      onChange={(e) => handleChange(subject.id, "subject_id", e.target.value)}
                      renderValue={(selected) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {selected && selected?.map((value, selectedIndex) => {
                            const subjectName = subjectList.find((sub) => sub.id === value)?.name;
                            return (
                              <Chip key={value} label={`${selectedIndex + 1}. ${subjectName}`} />
                            );
                          })}
                        </Box>
                      )}
                    >
                      {subjectList?.map((subjectOption, index) => (
                        <MenuItem key={subjectOption?.id} value={subjectOption?.id}>
                          {`${index + 1}. ${subjectOption?.name}`}
                        </MenuItem>
                      ))}
                    </Select>
                    {hasSubmitted && subject.subject_id.length === 0 && (
                      <FormHelperText>At least one subject must be selected</FormHelperText>
                    )}
                  </FormControl>
                  <IconButton onClick={() => handleDelete(subject.id)} color="error">
                    <DeleteIcon />
                  </IconButton>
                </Stack>
              </Paper>
            ))}
            <Button variant="contained" size="small" onClick={handleAdd} sx={{ mt: 2, py: 0.5, px: 2, width: "120px" }}>
              + Add
            </Button>
          </Stack>

          <Stack sx={{ my: 2 }}>
            <RHFTextEditor name="description" label="Description" />
          </Stack>

          <Stack width={"100%"}>
            <LoadingButton
              type="submit"
              variant="contained"
              size="large"
              loading={loading}
              sx={{
                bgcolor: "#e6e6ff",
                color: "black",
                width: "100%",
                marginTop: "2%",
                "&:hover": { background: "#8080ff" },
              }}
            >
              Create Live Test
            </LoadingButton>
          </Stack>
        </FormProvider>
        <ToastContainer position="bottom-center" autoClose={1000} hideProgressBar />
      </Box>
    </Page>
  );
};

export default CreateLiveTest;
